module.exports = __webpack_public_path__ + "static/media/mer_logo.0393e11e.svg";